import { render, staticRenderFns } from "./isAdult.vue?vue&type=template&id=498ba3a2&scoped=true"
import script from "./isAdult.vue?vue&type=script&lang=js"
export * from "./isAdult.vue?vue&type=script&lang=js"
import style0 from "./isAdult.vue?vue&type=style&index=0&id=498ba3a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ba3a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLogo: require('/app/components/icons/iconLogo.vue').default})
